var React = require('react');

function CircleFilled12x12 (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6","cy":"6","r":"6","fill":"currentColor"}));
}

CircleFilled12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CircleFilled12x12;

CircleFilled12x12.default = CircleFilled12x12;
